import CloseIcon from "@mui/icons-material/Close";
import FormatListBulletedIcon from "@mui/icons-material/FormatListBulleted";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import Tooltip from "@mui/material/Tooltip";
import { useContext } from "react";
import { useRedirect } from "react-admin";
import { useMatch } from "react-router";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { OpenTabsContext } from "../OpenTabsContext";
const CustomHomeLinkBox = ({ ...props }) => {
  return (
    <Box
      sx={{
        width: "100%",
        border: "1px solid #e0e0e3",
        borderBottom: "none",
        borderTopLeftRadius: 10,
        borderTopRightRadius: 10,
        height: "auto",
        padding: "0.8rem 0.8rem 0.3rem 0.8rem",
        bgcolor: "#fcfcfe",
        color: "grey",
        fontWeight: "bold",
        fontSize: "0.875rem",
        pr: 0,
        "&:hover": {
          bgcolor: "#f0f0f0",
        },
        "&.active": {
          bgcolor: "rgb(248, 249, 249)",
          backgroundColor: "#edf4fb",
        },
      }}
      {...props}
    />
  );
};
const CustomLinkBox = ({ ...props }) => {
  return (
    <Box
      sx={{
        width: "100%",
        border: "1px solid #e0e0e3",
        borderBottom: "none",
        borderTopLeftRadius: 10,
        borderTopRightRadius: 10,
        height: "auto",
        // padding: "0.8rem 0.8rem 0.8rem 0.8rem",
        padding: "0.8rem 0.3rem 0.8rem 0.3rem",
        bgcolor: "#fcfcfe",
        color: "grey",
        fontWeight: "bold",
        fontSize: "0.875rem",
        pr: 0,
        "&:hover": {
          bgcolor: "#f0f0f0",
        },
        "&.active": {
          bgcolor: "rgb(248, 249, 249)",
          backgroundColor: "#edf4fb",
        },
      }}
      {...props}
    />
  );
};

const ContainerTabLink = ({ ...props }) => {
  const { tabtype, id, loannum, activeTab } = props;
  const {
    openGlobalTabs,
    addGlobalTab,
    removeGlobalTab,
    removeGlobalTabName,
    setRemoveGlobalTabName,
  } = useContext(OpenTabsContext);
  // const navigate = useNavigate();
  // const redirectTo = useRedirect();
  const handleCloseTab = (closeTab: string) => () => {
    // alert("close tab: " + closeTab);
    localStorage.removeItem("backUrl-" + id + "-" + loannum);
    removeGlobalTab(closeTab);
    return false;
  };
  let active = tabtype + "-" + id == activeTab ? true : false;
  let linkto = "";
  let linktitle = "";
  let linkid = "";
  if (tabtype == "app") {
    linkto =
      `applicationSummary/` + id + (loannum ? "?loannum=" + loannum : "");
    linktitle = "App ";
    linkid = id;
  } else if (tabtype == "loan") {
    linkto = `loanSummary/` + id + (loannum ? "?loannum=" + loannum : "");
    linktitle = "Loan ";
    linkid = loannum ? loannum : id;
  } else if (tabtype == "user") {
    linkto = `userSummary/` + id;
    linktitle = "User ";
    linkid = id;
  }
  const LoanSmallIcon = ({ ...props }) => {
    const sx = props.sx;
    return <img src="/public/icon/loan-grey-v2.png" style={sx} />;
  };
  const AppSmallIcon = ({ ...props }) => {
    const sx = props.sx;
    return <img src="/public/icon/app-grey-icon.png" style={sx} />;
  };
  const UserSmallIcon = ({ ...props }) => {
    const sx = props.sx;
    return <img src="/public/icon/user-grey-icon.png" style={sx} />;
  };
  return (
    <CustomLinkBox className={active ? "active" : ""}>
      {tabtype == "app" && (
        <AppSmallIcon
          sx={{
            fontSize: "1rem",
            width: "15px",
            height: "15px",
            ml: 0,
            marginRight: "5px",
            marginTop: "2px",
            float: "left",
          }}
        />
      )}
      {tabtype == "loan" && (
        <LoanSmallIcon
          sx={{
            fontSize: "1rem",
            width: "15px",
            height: "15px",
            ml: 0,
            marginRight: "5px",
            marginTop: "2px",
            float: "left",
          }}
        />
      )}
      {tabtype == "user" && (
        <UserSmallIcon
          sx={{
            fontSize: "1rem",
            width: "15px",
            height: "15px",
            ml: 0,
            marginRight: "5px",
            marginTop: "2px",
            float: "left",
          }}
        />
      )}
      <Tooltip title="Close" placement="right-start">
        <CloseIcon
          sx={{
            fontSize: "1.5rem",
            ml: 1,
            mr: 1,
            mt: -1,
            color: "grey",
            // width: "35px",
            // padding: "8px 0px",
            // height: "35px",
            // display: "block",
            // background: "pink",
            borderRadius: "50%",
            float: "right",
            "&:hover": {
              color: "#1976d2",
              cursor: "pointer",
              background: "#eaeaea",
            },
          }}
          onClick={handleCloseTab(tabtype + "-" + id + "-" + loannum)}
        />
      </Tooltip>
      <Link
        to={linkto}
        className="tab-link-text"
        style={{
          textDecoration: "none",
          fontSize:
            linkid.length > 9
              ? "0.60rem"
              : linkid.length > 7
              ? "0.75rem"
              : "0.875rem",
        }}
      >
        {linktitle} <span className="numericText">{linkid}</span>
      </Link>
    </CustomLinkBox>
  );
};

const AppHeaderTab = ({ ...props }) => {
  const { openGlobalTabs, addGlobalTab, removeGlobalTab } =
    useContext(OpenTabsContext);

  const match = useMatch("/applicationSummary/:id");
  let activeAppId = match ? match.params.id : null;
  const matchloan = useMatch("/loanSummary/:id");
  let activeLoanId = matchloan ? matchloan.params.id : null;
  const matchuser = useMatch("/userSummary/:id");
  let activeUserId = matchuser ? matchuser.params.id : null;

  let activeTab = "";
  if (activeAppId != null && activeAppId != undefined) {
    activeTab = "app-" + activeAppId;
  }
  if (activeLoanId != null && activeLoanId != undefined) {
    activeTab = "loan-" + activeLoanId;
  }
  if (activeUserId != null && activeUserId != undefined) {
    activeTab = "user-" + activeUserId;
  }
  const location = useLocation();
  let pathname = location.pathname;
  pathname = pathname.replace("/", "");
  let parmsearch = location.search;
  if (parmsearch == null || parmsearch == "" || parmsearch == "/") {
    parmsearch = "";
  } else {
    pathname = pathname + parmsearch;
  }

  let mainpathname = localStorage.getItem("mainpathname");
  if (mainpathname == null || mainpathname == "") {
    mainpathname = "/";
  }

  return (
    <>
      <Grid container sx={{ width: "100%" }}>
        <Grid item sx={{ width: "50px" }} key="maintabpage">
          <CustomHomeLinkBox
            className={
              activeAppId == null &&
              activeLoanId == null &&
              activeUserId == null
                ? "active"
                : ""
            }
          >
            <Link
              to={mainpathname}
              style={{
                textDecoration: "none",
                color: "grey",
                textAlign: "center",
              }}
            >
              <Tooltip title="Return to last list" placement="right-start">
                <FormatListBulletedIcon
                  sx={{ fontSize: "1.45rem", color: "#03363d" }}
                />
              </Tooltip>
            </Link>
          </CustomHomeLinkBox>
        </Grid>
        {openGlobalTabs.length > 0 &&
          openGlobalTabs.map((curTab: any) => {
            let tabarr = curTab.split("-");
            let tabtype = tabarr[0];
            let tabId = tabarr[1];
            // let tabLoanNum = tabarr[2] ? tabarr[2] : "";
            let tabLoanNum = "";
            if (tabarr.length >= 3) {
              tabLoanNum = tabarr.slice(2).join("-");
            }
            return (
              <Grid
                item
                sx={{ width: "165px" }}
                key={tabtype + "-" + tabId + "-" + tabLoanNum}
              >
                <ContainerTabLink
                  id={tabId}
                  key={tabId}
                  tabtype={tabtype}
                  loannum={tabLoanNum}
                  activeTab={activeTab}
                />
              </Grid>
            );
          })}
      </Grid>
    </>
  );
};

export default AppHeaderTab;
